import getMenuList from './getMenuList';

export default getMenuList;
